(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-hero-slider')) {
    customElements.define('bb-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-bb-slide]')];
        this.dots = [...this.querySelectorAll('[data-bb-dot]')];
        this.status = this.querySelector('[data-bb-status]');
        this.pauseButton = this.querySelector('[data-bb-pause]');
        this.index = 0;
        this.playing = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.delay = Number(this.dataset.delay) || 6000;
        this.querySelector('[data-bb-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-bb-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.bbDot), true)));
        this.pauseButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.index - 1, true);
          if (event.key === 'ArrowRight') this.show(this.index + 1, true);
        });
        this.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStart == null) return;
          const distance = event.clientX - this.pointerStart;
          if (Math.abs(distance) > 45) this.show(this.index + (distance < 0 ? 1 : -1), true);
          this.pointerStart = null;
        });
        if (this.playing) this.start();
        else this.updatePauseButton();
      }
      disconnectedCallback() { this.stop(); }
      show(nextIndex, userInitiated) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
        if (userInitiated && this.playing) this.start();
      }
      start() {
        this.stop();
        if (this.slides.length > 1) this.timer = window.setInterval(() => this.show(this.index + 1, false), this.delay);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
      toggleAutoplay() {
        this.playing = !this.playing;
        if (this.playing) this.start();
        else this.stop();
        this.updatePauseButton();
      }
      updatePauseButton() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-label', this.playing ? 'Otomatik geçişi duraklat' : 'Otomatik geçişi başlat');
        const pauseIcon = this.pauseButton.querySelector('[data-bb-pause-icon]');
        const playIcon = this.pauseButton.querySelector('[data-bb-play-icon]');
        if (pauseIcon) pauseIcon.hidden = !this.playing;
        if (playIcon) playIcon.hidden = this.playing;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var deliveryDraft = null;
    var deliveryAreas = {
      'Kocaeli': [
        ['Darıca', '41700'],
        ['Gebze', '41400']
      ],
      'İstanbul Anadolu Yakası': [
        ['Adalar', '34970'],
        ['Ataşehir', '34758'],
        ['Beykoz', '34800'],
        ['Çekmeköy', '34782'],
        ['Kadıköy', '34710'],
        ['Kartal', '34860'],
        ['Maltepe', '34840'],
        ['Pendik', '34890'],
        ['Sancaktepe', '34785'],
        ['Sultanbeyli', '34920'],
        ['Şile', '34980'],
        ['Tuzla', '34940'],
        ['Ümraniye', '34760'],
        ['Üsküdar', '34660']
      ],
      'İstanbul Avrupa Yakası': [
        ['Bahçelievler', '34180'],
        ['Bakırköy', '34158'],
        ['Bayrampaşa', '34040'],
        ['Beşiktaş', '34349'],
        ['Beyoğlu', '34420'],
        ['Esenler', '34220'],
        ['Eyüpsultan', '34050'],
        ['Fatih', '34080'],
        ['Gaziosmanpaşa', '34245'],
        ['Güngören', '34160'],
        ['Kağıthane', '34406'],
        ['Sarıyer', '34450'],
        ['Şişli', '34381'],
        ['Zeytinburnu', '34020']
      ]
    };

    function createOption(value, text) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = text;
      return option;
    }

    function setNativeValue(input, value) {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function activeDeliveryMethod(app) {
      var active = app.querySelector('.checkoutMethod.active');
      return Boolean(active && active.querySelector('.deliveryIcon'));
    }

    function setCheckoutLocked(locked) {
      document.querySelectorAll('button[name="checkout"]').forEach(function (button) {
        if (locked) {
          if (!button.hasAttribute('data-bb-delivery-lock')) button.setAttribute('data-bb-delivery-lock', '');
          if (!button.disabled) button.disabled = true;
          if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
        } else if (button.hasAttribute('data-bb-delivery-lock')) {
          button.removeAttribute('data-bb-delivery-lock');
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
      });
    }

    function setupDeliveryArea() {
      var config = document.querySelector('.bb-delivery-area-config');
      var app = document.querySelector('#storePickupApp');
      if (app && !activeDeliveryMethod(app)) setCheckoutLocked(false);
      // The app marks its optional note as required again when its calendar renders.
      var note = app && app.querySelector('#deliveryNote');
      var noteLabel = app && app.querySelector('label[for="deliveryNote"]');
      if (note && noteLabel && /isteğe bağlı|optional/i.test(noteLabel.textContent)) {
        if (note.required) note.required = false;
        if (note.hasAttribute('aria-required')) note.removeAttribute('aria-required');
      }
      var postalInput = app && app.querySelector('#deliveryGeoSearchField');
      var deliveryContainer = postalInput && postalInput.closest('.checkoutMethodContainer.delivery');
      var inputWithButton = postalInput && postalInput.closest('.inputWithButton');
      if (!config || !app || !postalInput || !deliveryContainer || !inputWithButton) return;

      if (!deliveryDraft) {
        deliveryDraft = {
          region: config.dataset.savedRegion || '',
          district: config.dataset.savedDistrict || '',
          address: config.dataset.savedAddress || ''
        };
      }
      // The delivery app replaces this class after selecting a date.
      if (!deliveryContainer.classList.contains('bb-delivery-area-ready')) {
        deliveryContainer.classList.add('bb-delivery-area-ready');
      }

      var existing = deliveryContainer.querySelector('.bb-delivery-area');
      if (existing) {
        var existingDistrict = existing.querySelector('[data-bb-district]');
        var existingAddress = existing.querySelector('.bb-delivery-area__address');
        var deliveryActive = activeDeliveryMethod(app);
        if (existing.hidden === deliveryActive) existing.hidden = !deliveryActive;
        existing.querySelectorAll('select, textarea').forEach(function (field) {
          var disabled = !deliveryActive || (field === existingDistrict && !existing.querySelector('#bb-delivery-region').value);
          if (field.disabled !== disabled) field.disabled = disabled;
        });
        if (
          deliveryActive &&
          (!existingDistrict || !existingDistrict.value || !existingAddress || existingAddress.value.trim().length < 10)
        ) {
          setCheckoutLocked(true);
        } else {
          setCheckoutLocked(false);
        }
        return;
      }

      deliveryContainer.classList.add('bb-delivery-area-ready');
      var panel = document.createElement('section');
      panel.className = 'bb-delivery-area';
      panel.setAttribute('aria-labelledby', 'bb-delivery-area-heading');

      var heading = document.createElement('h3');
      heading.className = 'bb-delivery-area__heading';
      heading.id = 'bb-delivery-area-heading';
      heading.textContent = config.dataset.heading;

      var description = document.createElement('p');
      description.className = 'bb-delivery-area__description';
      description.textContent = config.dataset.description;

      var fields = document.createElement('div');
      fields.className = 'bb-delivery-area__fields';

      var regionLabel = document.createElement('label');
      regionLabel.className = 'bb-delivery-area__field';
      regionLabel.htmlFor = 'bb-delivery-region';
      regionLabel.textContent = config.dataset.regionLabel;

      var region = document.createElement('select');
      region.className = 'bb-delivery-area__select';
      region.id = 'bb-delivery-region';
      region.name = 'attributes[Teslimat bölgesi]';
      region.setAttribute('form', 'cart');
      region.required = true;
      region.appendChild(createOption('', config.dataset.regionPlaceholder));
      Object.keys(deliveryAreas).forEach(function (area) {
        region.appendChild(createOption(area, area));
      });
      regionLabel.appendChild(region);

      var districtLabel = document.createElement('label');
      districtLabel.className = 'bb-delivery-area__field';
      districtLabel.htmlFor = 'bb-delivery-district';
      districtLabel.textContent = config.dataset.districtLabel;

      var district = document.createElement('select');
      district.className = 'bb-delivery-area__select';
      district.id = 'bb-delivery-district';
      district.setAttribute('data-bb-district', '');
      district.required = true;
      district.disabled = true;
      district.appendChild(createOption('', config.dataset.districtPlaceholder));
      districtLabel.appendChild(district);

      var districtAttribute = document.createElement('input');
      districtAttribute.type = 'hidden';
      districtAttribute.name = 'attributes[Teslimat ilçesi]';
      districtAttribute.setAttribute('form', 'cart');

      var addressLabel = document.createElement('label');
      addressLabel.className = 'bb-delivery-area__field bb-delivery-area__address-field';
      addressLabel.htmlFor = 'bb-delivery-address';
      addressLabel.textContent = config.dataset.addressLabel;

      var address = document.createElement('textarea');
      address.className = 'bb-delivery-area__address';
      address.id = 'bb-delivery-address';
      address.name = 'attributes[Teslimat açık adresi]';
      address.setAttribute('form', 'cart');
      address.setAttribute('autocomplete', 'street-address');
      address.placeholder = config.dataset.addressPlaceholder;
      address.required = true;
      address.minLength = 10;
      addressLabel.appendChild(address);

      var status = document.createElement('p');
      status.className = 'bb-delivery-area__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');

      fields.appendChild(regionLabel);
      fields.appendChild(districtLabel);
      fields.appendChild(districtAttribute);
      fields.appendChild(addressLabel);
      panel.appendChild(heading);
      panel.appendChild(description);
      panel.appendChild(fields);
      panel.appendChild(status);
      deliveryContainer.insertBefore(panel, inputWithButton);

      function rememberDelivery() {
        deliveryDraft = {
          region: region.value,
          district: districtAttribute.value,
          address: address.value
        };
      }

      region.value = deliveryDraft.region;
      (deliveryAreas[region.value] || []).forEach(function (item) {
        var option = createOption(item[1], item[0]);
        option.setAttribute('data-bb-district-name', item[0]);
        district.appendChild(option);
        if (item[0] === deliveryDraft.district) {
          district.value = item[1];
          districtAttribute.value = item[0];
        }
      });
      address.value = deliveryDraft.address;
      district.disabled = !region.value;
      // Preserve the app's selected date when it already has the same area.
      if (district.value) {
        var restoredPostal = region.value === 'İstanbul Avrupa Yakası' ? '34349' : district.value;
        if (postalInput.value !== restoredPostal) {
          setNativeValue(postalInput, restoredPostal);
          var restoredSubmit = inputWithButton.querySelector('[role="button"], button');
          if (restoredSubmit) restoredSubmit.click();
        }
      }

      region.addEventListener('change', function () {
        district.innerHTML = '';
        district.appendChild(createOption('', config.dataset.districtPlaceholder));
        district.disabled = !region.value;
        districtAttribute.value = '';
        status.textContent = '';
        setNativeValue(postalInput, '');
        setCheckoutLocked(activeDeliveryMethod(app));
        (deliveryAreas[region.value] || []).forEach(function (item) {
          var option = createOption(item[1], item[0]);
          option.setAttribute('data-bb-district-name', item[0]);
          district.appendChild(option);
        });
        rememberDelivery();
        if (!district.disabled) district.focus();
      });

      district.addEventListener('change', function () {
        if (!district.value) {
          districtAttribute.value = '';
          setNativeValue(postalInput, '');
          status.textContent = '';
          setCheckoutLocked(activeDeliveryMethod(app));
          rememberDelivery();
          return;
        }
        districtAttribute.value = district.options[district.selectedIndex].getAttribute('data-bb-district-name') || '';
        rememberDelivery();
        status.textContent = config.dataset.checking;
        var validationPostalCode = region.value === 'İstanbul Avrupa Yakası' ? '34349' : district.value;
        setNativeValue(postalInput, validationPostalCode);
        var submit = inputWithButton.querySelector('[role="button"], button');
        if (submit) submit.click();
        window.setTimeout(function () {
          status.textContent = '';
        }, 2000);
      });

      address.addEventListener('input', function () {
        rememberDelivery();
        setCheckoutLocked(activeDeliveryMethod(app) && (!district.value || address.value.trim().length < 10));
      });

      app.addEventListener('click', function () {
        window.setTimeout(function () {
          setupDeliveryArea();
        }, 0);
      });

      panel.hidden = !activeDeliveryMethod(app);
      region.disabled = address.disabled = !activeDeliveryMethod(app);
      district.disabled = !activeDeliveryMethod(app) || !region.value;
      setCheckoutLocked(activeDeliveryMethod(app) && (!district.value || address.value.trim().length < 10));
    }

    function initializeDeliveryArea() {
      setupDeliveryArea();
      var observer = new MutationObserver(setupDeliveryArea);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeDeliveryArea);
    } else {
      initializeDeliveryArea();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
